<!-- Spinner -->

<!-- Content -->
@if ((appSharedFacade.metadata$ | async); as metadata) {
  <div class="mdsf-carousel p-0 m-0 w-100">
    <!-- Image -->
    @if (metadata.carouselMedia && (appSharedFacade.media$(metadata.carouselMedia) | async); as media) {
      @if (mediaControlService.getUrl(media); as mediaSrc) {
        <img class="mdsf-carousel-image w-100 h-100"
          ngSrc="{{ mediaSrc }}"
          fill="true"
          priority
          alt="decorative Carousel image">
      }
    }
    <!-- Title -->
    @if (metadata.carouselTitle) {
      <h1
        class="mdsf-carousel-header text-uppercase"
        [style]="{ color: metadata.carouselTextColor }"
        [innerHTML]="metadata.carouselTitle">
      </h1>
    }
    <!-- Copyright -->
    @if (metadata.carouselCopyright) {
      <p
        class="mdsf-carousel-copyright"
        [style]="{ color: metadata.carouselTextColor }"
        [innerHTML]="metadata.carouselCopyright">
      </p>
    }
  </div>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
